<script>
//
export let pageCopy;
export let pageTitle;
let theTitle;

if (pageTitle !== null) {
    theTitle = pageTitle;

} else {
    theTitle = "";
}

</script>
<section>

	<div class="para">
    {#if theTitle !== ""}
    	<h2>{@html pageTitle}</h2>
    {/if }
    <div class="para-container">
        <p>{@html pageCopy}</p>
    </div>
    </div>
</section>